'use client';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useTheme } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react';
export function CustomGrid({ rows, columns, sortModel, onSortModelChange, onRowClick, getRowClassName, checkboxSelection, rowSelectionModel, onRowSelectionModelChange, disableRowSelectionOnClick = true, sx }) {
    const theme = useTheme();
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10
    });
    return (_jsx(_Fragment, { children: _jsx(DataGrid, { rows: rows, columns: columns, sortModel: sortModel, onSortModelChange: onSortModelChange, getRowClassName: getRowClassName, disableRowSelectionOnClick: disableRowSelectionOnClick, pagination: true, onRowClick: onRowClick, paginationModel: paginationModel, onPaginationModelChange: setPaginationModel, pageSizeOptions: [10, 25, 50, 100], autoHeight: true, checkboxSelection: checkboxSelection, rowSelectionModel: rowSelectionModel, onRowSelectionModelChange: onRowSelectionModelChange, sx: {
                borderRadius: 2,
                boxShadow: theme.customShadows.card,
                maxHeight: 'calc(100vh - 220px)',
                '& .MuiDataGrid-row.row-disabled': {
                    opacity: 0.5,
                    cursor: 'not-allowed',
                },
                '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: theme.palette.background.paper,
                    zIndex: 1,
                    position: 'sticky',
                    top: 0,
                },
                '& .MuiDataGrid-main': {
                    overflow: 'auto',
                },
                '& .MuiDataGrid-virtualScroller': {
                    paddingTop: 0,
                    overflow: 'auto !important',
                },
                '& .MuiDataGrid-footerContainer': {
                    mt: 1.5,
                },
                '& .MuiDataGrid-cell:focus': {
                    outline: 'none'
                },
                '& .MuiDataGrid-cell:focus-within': {
                    outline: 'none'
                },
                ...sx
            } }) }));
}
